import React from 'react';
import { SceneProps } from '../../types/reel';
import { easeOut, progress, punch, reveal } from '../../utils/reelMath';
import { IsdinPhone, IsdinScreen } from './IsdinPhone';
import { SceneLayer } from './SceneLayer';
const FAN: {
  screen: IsdinScreen;
  x: number;
  rot: number;
  scale: number;
  z: number;
}[] = [{
  screen: 'signup',
  x: -300,
  rot: -8,
  scale: 0.84,
  z: 1
}, {
  screen: 'points',
  x: -155,
  rot: -4,
  scale: 0.92,
  z: 2
}, {
  screen: 'scan',
  x: 0,
  rot: 0,
  scale: 1,
  z: 3
}, {
  screen: 'pdp',
  x: 155,
  rot: 4,
  scale: 0.92,
  z: 2
}];
export function IsdinScene({
  time,
  scene
}: SceneProps) {
  const fan = easeOut(progress(time, scene.start, scene.start + 0.45));
  const metric = reveal(time, scene.start + 1, 0.25);
  return <SceneLayer time={time} start={scene.start} end={scene.end} fade={0.12} data-id="element-73" data-mp="rpmb4d4vd2r5">
      {({
      p
    }) => <div className="absolute inset-0 bg-cream" style={{
      transform: `scale(${punch(time, scene.start) + 0.03 * p})`
    }} data-id="element-74" data-mp="3hgivsjo5ndnv">
          <div className="absolute left-[150px] top-1/2 -translate-y-1/2" data-id="element-75" data-mp="3cihart76549r">
            <p className="font-mono text-[20px] text-muted" data-id="element-76" data-mp="2i867fzrvem9y">ISDIN USA · E-commerce</p>
            <h2 className="mt-4 text-[112px] font-medium leading-[0.98] tracking-[-0.045em] text-ink" data-id="element-77" data-mp="2n5y0wy85ygg9">
              Redeem
              <br data-id="element-78" data-mp="298t13fz1mdtg" />
              program
            </h2>
            <p className="mt-10 text-[72px] font-medium tracking-[-0.045em] text-sage" style={{
          opacity: metric,
          transform: `translateY(${(1 - metric) * 14}px)`
        }} data-id="element-79" data-mp="2e4qgnk2hfg56">
              –18% <span className="text-[36px] font-medium tracking-[-0.02em] text-ink" data-id="element-80" data-mp="2496kqxnx4hgf">drop-off</span>
            </p>
          </div>

          <div className="absolute left-[1300px] top-[540px]" data-id="element-81" data-mp="1qedxfd1sdwza">
            {FAN.map(f => <div key={f.screen} className="absolute" style={{
          zIndex: f.z,
          transform: `translate(-50%, -50%) translateX(${f.x * fan}px) rotate(${f.rot * fan}deg) scale(${f.scale})`
        }} data-id="element-82" data-mp="1ufpntkshim8j">
                <IsdinPhone screen={f.screen} data-id="element-83" data-mp="3n84j1nt8np8x" />
              </div>)}
          </div>
        </div>}
    </SceneLayer>;
}